var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.962736 0.0385742H18.7284C19.1849 0.0385742 19.5546 0.408374 19.5546 0.864805V8.25428C19.5546 8.44417 19.4892 8.62867 19.369 8.77563L14.3149 14.9891L19.3661 21.1263C19.488 21.2741 19.5546 21.4597 19.5546 21.6513V28.9589C19.5546 29.4154 19.1848 29.7851 18.7283 29.7851L0.962981 29.7852C0.506446 29.7852 0.13675 29.4154 0.13675 28.959L0.136444 21.6514C0.136444 21.4598 0.203004 21.2742 0.324911 21.1264L5.37613 14.9892L0.322041 8.77599C0.202172 8.6284 0.136429 8.44452 0.136429 8.25464V0.865168C0.136429 0.408424 0.506229 0.0386239 0.962973 0.0386239L0.962736 0.0385742ZM17.4887 2.10436H2.20219V7.81366L7.83216 14.7334C7.95611 14.8859 7.9558 15.105 7.83043 15.2569L2.20176 22.0958V27.7197H17.4882L17.4885 22.0958L11.8601 15.2569C11.7354 15.1047 11.7344 14.8863 11.8584 14.7334L17.4884 7.8134L17.4887 2.10436Z",
    fill: "#1471C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0849 7.9108L10.7646 13.2545C10.59 13.4707 10.3539 13.6416 10.0822 13.6975C9.65221 13.7854 9.22769 13.6289 8.96227 13.3001L4.60515 7.91072C4.38671 7.64042 4.57926 7.23779 4.92652 7.23779H14.7638C15.1111 7.23749 15.3037 7.64042 15.0849 7.91072L15.0849 7.9108Z",
    fill: "#1471C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.06136 25.8608V23.7048C4.06136 23.5302 4.17113 23.3749 4.33513 23.3158L9.28876 21.5454C9.64815 21.4168 10.0415 21.4168 10.4009 21.5454L15.3545 23.3158C15.5193 23.3749 15.6292 23.5302 15.6292 23.7051V25.8608H4.06136Z",
    fill: "#1471C7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.18aedef9063b8c35851eebee70dcc032.svg";
export { ForwardRef as ReactComponent };